import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cb-loader',
  templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit {

  @Input() css: string = "w-12 h-4 text-brand-primary";

  constructor() { }

  ngOnInit(): void {
  }

}
